export interface BaseRoute {
  path: string;
  label?: string;
  backPath?: string;
  getPath?: (...args: any[]) => string;
}

type NestedRoute = BaseRoute & {
  [key: string]: BaseRoute | string | ((...args: any[]) => string) | undefined;
};

export interface RouteConfig {
  [key: string]: NestedRoute;
}

export const AppRoutes: RouteConfig = {
  auth: {
    path: '/auth',
    label: 'Авторизация',
    esia: {
      path: '/auth/esia',
      backPath: '/auth',
      label: 'Вход через ЕСИА',
    },
    ecp: {
      path: '/auth/ecp',
      backPath: '/auth',
      label: 'Вход с КЭП',
    },
    blocked: {
      path: '/auth/blocked',
      label: 'Вход временно заблокирован',
    },
    unavailable: {
      path: '/auth/unavailable',
      label: 'Вход недоступен',
    },
    esiaErrors: {
      path: '/auth/esia-errors',
      label: 'Ошибки ЕСИА',
    },
    registration: {
      path: '/auth/registration',
      label: 'Регистрация',
    },
  },

  application: {
    path: '/application/:id',
    getPath: (id: string) => `/application/${id}`,
    liquidityProviderList: {
      path: '/application/:id/liquidity-provider-list',
      getPath: (id: string) => `/application/${id}/liquidity-provider-list`,
    },
    liquidityProvider: {
      path: '/application/:id/liquidity-provider/:providerId',
      getPath: (id: string, providerId: string) =>
        `/application/${id}/liquidity-provider/${providerId}`,
    },
    form: {
      path: '/application/:id/form',
      getPath: (id: string) => `/application/${id}/form`,
    },
    contract: {
      path: '/application/:id/contract',
      getPath: (id: string) => `/application/${id}/contract`,
    },
    edit: {
      path: '/application/:id/edit',
      getPath: (id: string) => `/application/${id}/edit`,
    },
    document: {
      path: '/application/:id/document/:documentId?',
      getPath: (id: string, documentId?: string) =>
        documentId
          ? `/application/${id}/document/${documentId}`
          : `/application/${id}/document`,
    },
    documentList: {
      path: '/application/:id/document',
      getPath: (id: string) => `/application/${id}/document`,
    },
    create: {
      path: '/application/create',
    },
  },

  documents: {
    path: '/documents',
    label: 'Документы',
    documentsList: {
      path: '/documents',
      getPath: () => '/documents',
    },
  },

  profile: {
    path: '/profile',
    label: 'Профиль',
    getPath: () => `/profile`,
    profileEdit: {
      path: '/profile/edit',
    },
  },

  myApplicationList: {
    path: '/my-applications',
    label: 'Мои заявки',
  },

  notifications: {
    path: '/notifications',
    label: 'Уведомления',
    item: {
      path: '/notifications/:id',
      getPath: (id: string) => `/notifications/${id}`,
    },
  },

  help: {
    path: '/help',
    label: 'Помощь',
    faq: {
      path: '/help/faq',
    },
  },

  balance: { path: '/balance', label: 'Мой баланс', getPath: () => '/balance' },

  dashboard: {
    path: '/',
  },

  root: { path: '/' },
};
